// Format currency values
export const formatCurrency = (value) => {
  // Handle null, undefined, or empty values
  if (value === null || value === undefined || value === '') {
    return '€0.00';
  }
  
  // Convert to number if it's a string
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '€0.00';
  }
  
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numValue);
};

// Format date
export const formatDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

// Format date and time
export const formatDateTime = (date) => {
  return new Intl.DateTimeFormat('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
};

// Format number with decimals
export const formatNumber = (value, decimals = 2) => {
  // Handle null, undefined, or empty values
  if (value === null || value === undefined || value === '') {
    return '0';
  }
  
  // Convert to number if it's a string
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0';
  }
  
  return new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(numValue);
};

// Format percentage
export const formatPercentage = (value) => {
  return `${formatNumber(value, 2)}%`;
};

// Format order status
export const formatOrderStatus = (status) => {
  const statusMap = {
    draft: 'Borrador',
    pending: 'Pendiente',
    confirmed: 'Confirmado',
    reviewed: 'Revisado',
    out_of_stock: 'Sin Stock',
    cut: 'Cortado',
    stapled: 'Grapado',
    finished: 'Enmarcado',
    in_production: 'En Producción',
    ready: 'Listo',
    delivered: 'Entregado',
    invoiced: 'Facturado',
    cancelled: 'Cancelado'
  };
  
  return statusMap[status] || status;
};

// Get status color
export const getStatusColor = (status) => {
  const colorMap = {
    draft: '#6c757d',
    pending: '#ffc107',
    confirmed: '#007bff',
    reviewed: '#17a2b8',
    out_of_stock: '#dc3545',
    cut: '#fd7e14',
    stapled: '#e83e8c',
    finished: '#6f42c1',
    in_production: '#fd7e14',
    ready: '#20c997',
    delivered: '#28a745',
    invoiced: '#17a2b8',
    cancelled: '#dc3545'
  };
  
  return colorMap[status] || '#6c757d';
};